import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  iam: string,
  listingFor: string,
  property_type_id: number,
  distFromRoad: string,
  totalArea: string,
  houseArea: string,
  floor: number,
  price: number,
  propertyTypes: Array<any>
}

@Component({
  selector: 'app-edit-propery-type',
  templateUrl: './edit-propery-type.component.html',
  styleUrls: ['./edit-propery-type.component.css']
})
export class EditProperyTypeComponent{

  basicInfoForm: FormGroup = new FormGroup({
    iam: new FormControl('', [Validators.required]),
    listingFor: new FormControl('', [Validators.required]),
    property_type_id: new FormControl(null, [Validators.required]),
    distFromRoad: new FormControl(''),
    bigha: new FormControl(null),
    kattha: new FormControl(null),
    dhur: new FormControl(null),
    kanwa: new FormControl(null),
    totalArea: new FormControl('', [Validators.required]),
    ropani: new FormControl(null),
    aana: new FormControl(null),
    paisa: new FormControl(null),
    daam: new FormControl(null),
    houseArea: new FormControl(null),
    floor: new FormControl(null),
    price: new FormControl(null, [Validators.required]),
  })

  property: any

  selectedUnitDistance: string

  propertyTypes = []

  constructor(
    public dialogRef: MatDialogRef<EditProperyTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.propertyTypes = data.propertyTypes
      delete data['propertyTypes']
      this.property = data
      if(this.property.totalArea){
        if(this.property.totalArea.indexOf('-') > -1){
          let parts = this.property.totalArea.split('-')
          this.property['bigha'] = parts[0] ? Number(parts[0]) : 0
          this.property['kattha'] = parts[1] ? Number(parts[1]) : 0
          this.property['dhur'] = parts[2] ? Number(parts[2]) : 0
          this.property['kanwa'] = parts[3] ? Number(parts[3]) : 0
        }else{
          let totalArea = data.totalArea.split(/\s+/)
          this.property['bigha'] = totalArea[0] ? Number(totalArea[0]) : 0
          this.property['kattha'] = 0
          this.property['dhur'] = 0
          this.property['kanwa'] = 0
        }
      } else {
        this.property['bigha'] = 0
        this.property['kattha'] = 0
        this.property['dhur'] = 0
        this.property['kanwa'] = 0
        this.property['totalArea'] = '0-0-0-0'
      }
      if(this.property.houseArea){
        if(this.property.houseArea.indexOf('-') > -1){
          let parts = this.property.houseArea.split('-')
          this.property['ropani'] = parts[0] ? Number(parts[0]) : 0
          this.property['aana'] = parts[1] ? Number(parts[1]) : 0
          this.property['paisa'] = parts[2] ? Number(parts[2]) : 0
          this.property['daam'] = parts[3] ? Number(parts[3]) : 0
        }else{
          let houseArea = data.houseArea.split(/\s+/)
          this.property['ropani'] = houseArea[0] ? Number(houseArea[0]) : 0
          this.property['aana'] = 0
          this.property['paisa'] = 0
          this.property['daam'] = 0
        }
      } else {
        this.property['ropani'] = null
        this.property['aana'] = null
        this.property['paisa'] = null
        this.property['daam'] = null
      }
      if(this.property.distFromRoad){
        let distFromRoad = data.distFromRoad.split(/\s+/)
        this.property['distFromRoad'] = distFromRoad[0]
        this.selectedUnitDistance = distFromRoad[1]
      }
      this.basicInfoForm.patchValue(this.property)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateTotalArea() {
    const b = this.basicInfoForm.get('bigha').value;
    const k = this.basicInfoForm.get('kattha').value;
    const d = this.basicInfoForm.get('dhur').value;
    const kw = this.basicInfoForm.get('kanwa').value;
    if ((b !== null && b !== '') || (k !== null && k !== '') || (d !== null && d !== '') || (kw !== null && kw !== '')) {
      const bigha = b !== null && b !== '' ? b : 0;
      const kattha = k !== null && k !== '' ? k : 0;
      const dhur = d !== null && d !== '' ? d : 0;
      const kanwa = kw !== null && kw !== '' ? kw : 0;
      this.basicInfoForm.get('totalArea').setValue(`${bigha}-${kattha}-${dhur}-${kanwa}`);
    } else {
      this.basicInfoForm.get('totalArea').setValue('');
    }
  }

  updateHouseArea() {
    const r = this.basicInfoForm.get('ropani').value;
    const a = this.basicInfoForm.get('aana').value;
    const p = this.basicInfoForm.get('paisa').value;
    const dm = this.basicInfoForm.get('daam').value;
    if ((r !== null && r !== '') || (a !== null && a !== '') || (p !== null && p !== '') || (dm !== null && dm !== '')) {
      const ropani = r !== null && r !== '' ? r : 0;
      const aana = a !== null && a !== '' ? a : 0;
      const paisa = p !== null && p !== '' ? p : 0;
      const daam = dm !== null && dm !== '' ? dm : 0;
      this.basicInfoForm.get('houseArea').setValue(`${ropani}-${aana}-${paisa}-${daam}`);
    } else {
      this.basicInfoForm.get('houseArea').setValue(null);
    }
  }

  savePropertyBasicInfo(){
    if(this.basicInfoForm.valid){
      this.updateTotalArea();
      this.updateHouseArea();
      let basicInfo = this.basicInfoForm.value;
      delete basicInfo.bigha;
      delete basicInfo.kattha;
      delete basicInfo.dhur;
      delete basicInfo.kanwa;
      delete basicInfo.ropani;
      delete basicInfo.aana;
      delete basicInfo.paisa;
      delete basicInfo.daam;
      basicInfo['distFromRoad'] = basicInfo['distFromRoad'] ? (basicInfo['distFromRoad'] + ' ' + this.selectedUnitDistance) : null;
      this.dialogRef.close(basicInfo);
    }
  }
}
